import uuid from 'uuid'

const crossTabActionKey = 'ctakey'
const currentTabKey = uuid.v4()

export function crossTabAction (action) {
  window.localStorage.setItem(crossTabActionKey, currentTabKey)
  setTimeout(() => {
    const storedKey = window.localStorage.getItem(crossTabActionKey)
    if (storedKey === currentTabKey) {
      action()
    }
  }, 3000)
}



// WEBPACK FOOTER //
// ./src/utils/crossTabAction.js